<template>
  <div>
    <v-dialog v-model="chargeDialog" max-width="400" persistent>
      <div>
        <v-card>
          <v-card-title class="coggiri-middle-subject pt-5 pl-5 pb-5"
            >[유료 멤버십 서비스] 충전하기</v-card-title
          >

          <v-card-text class="pl-5">
            <p class="membershipSettingTextInfo mb-0">
              현재 비즈포인트 잔액이 부족합니다.
            </p>
            <p class="membershipSettingTextInfo mb-0">
              아래 충전하기 버튼을 클릭하여 포인트를 충전해주세요.
            </p>
            <p class="membershipSettingTextInfo mb-0">
              * 매월 1일 기준으로 3영업일 (4일까지) 미충전시 사용중인 멤버십
            </p>
            <p class="membershipSettingTextInfo mb-0">
              서비스가 중지됩니다.
            </p>
          </v-card-text>

          <v-row class="pt-0 pb-0 col-xl-12 col-lg-12 ml-0 mr-0 mb-5 pl-5 pr-5">
            <div
              style="background-color: rgb(248, 248, 248); width:100%;"
              class="pa-3"
            >
              <p class="membershipSettingTextInfo mb-0">
                [쇼핑몰명]
              </p>
              <p class="membershipSettingTextInfo mb-0">
                - 현재 사용중 회원 {{ use_member_count }}명
              </p>
              <p class="membershipSettingTextInfo mb-0">
                - 잔액 비즈포인트 :{{ residual_point }} 포인트
              </p>
              <p class="membershipSettingTextInfo mb-0">
                - 소진 비즈포인트 : {{ use_point }} 포인트
              </p>
              <p class="membershipSettingTextInfo mb-0">
                - 남은 비즈포인트 : {{ remain_point }} 포인트
              </p>
            </div>
          </v-row>

          <v-btn
            color="black"
            hide-details
            depressed
            class="ml-5 mb-5 white--text"
            @click="chargeDialog = false"
            width="126"
            >닫기</v-btn
          >

          <v-btn
            color="primary"
            hide-details
            class="white--text ml-2 mb-5 pl-4 pr-4 mr-5"
            depressed
            width="226"
            @click="pgPageMove()"
            >충전하기</v-btn
          >
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import common from "@/libs/common.js";
export default {
  data: () => {
    return {
      chargeDialog: false,
      use_member_count: 0,
      residual_point: 0,
      use_point: 0,
      remain_point: 0,
    };
  },
  methods: {
    show: async function() {
      let result = await this.getUseStatus();
      if (result === false) {
        this.chargeDialog = true;
      }
    },
    pgPageMove: function() {
      this.$router.push({
        path: `/membership/${this.$store.state.mallId}/payment`,
      });
    },
    getUseStatus: async function() {
      try {
        let res = await M.api(M.entry("/get/membership/usage"));
        this.use_member_count = common.comma(res.number_of_members);
        this.residual_point = common.comma(res.points.balance);
        this.use_point = common.comma(res.points.used);

        let remain_point = res.points.balance - res.points.used;
        if (remain_point < 0) {
          remain_point = 0;
        }
        this.remain_point = common.comma(remain_point);
        if (res.points.balance <= 0) {
          return false;
        } else {
          return true;
        }
      } catch (e) {
        return true;
      }
    },
  },
};
</script>
